import React, { Component } from "react";
import classNames from "classnames";

/**
 * @param (object Array) this.props.dataSource
 * @param (function) this.props.onChange (will recive new dataSouceArray)
 * @param (boolean)  expanded (show or hide)
 * @param (function) used to close expanded variable with this.props.closeFunction(false)
 */
class DropdownCheckboxes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.dataSource.slice() || []
        };

        this.dropdownRef = React.createRef();
        this.keyEventHandler = this.keyEventHandler.bind(this);
        this.close = this.close.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.updateItem = this.updateItem.bind(this);
        this.checkboxSubmitHandler = this.checkboxSubmitHandler.bind(this);
    }

    close() {
        this.setState({
            data: this.props.dataSource
        });
        this.props.closeFunction(false);
    }

    keyEventHandler(e) {
        if (e.key == "Escape") {
            this.close();
        }
    }

    componentDidUpdate() {
        if (this.props.expanded) {
            document.addEventListener("click", this.handleClickOutside, { capture: true });
            document.addEventListener("keyup", this.keyEventHandler);
        } else {
            document.removeEventListener("click", this.handleClickOutside, { capture: true });
            document.removeEventListener("keyup", this.keyEventHandler);
        }
    }

    handleClickOutside(event) {
        const domNode = this.dropdownRef.current;
        if (!domNode || !domNode.contains(event.target)) {
            this.close();
        }
    }

    checkboxSubmitHandler() {
        this.props.onChange(this.state.data);
    }

    updateItem(item, idx) {
        const arr = this.state.data;
        const newarr = arr.slice().map((obj, i) => {
            if (i == idx) {
                obj.Selected = !item.Selected;
            }
            return Object.assign({}, obj);
        });
        this.setState({
            data: newarr
        });
    }

    render() {
        const list = (
            <ul>
                {this.state.data.map((item, idx) => {
                    return (
                        <li key={idx} className="dropdown-checkbox__option">
                            <label className="checkbox" htmlFor={item.Label}>
                                <span hidden>{item.Label}</span>
                                <input
                                    id={item.Label}
                                    type="checkbox"
                                    className="checkbox__input"
                                    checked={item.Selected}
                                    onChange={() => {
                                        this.updateItem(item, idx);
                                    }}
                                />
                                <div className="dropdown-checkbox__option__text">
                                    <span>{item.Label}</span>
                                    <span className="dropdown-checkbox__option__text__details">
                                        {item.Details}
                                    </span>
                                </div>
                                <div className="checkbox__indicator"></div>
                            </label>
                        </li>
                    );
                })}
            </ul>
        );

        const classes = classNames({
            "dropdown-checkbox": true,
            isExpanded: this.props.expanded
        });
        const selectBtnText = this.props.selectBtnText || "Vælg klasser";

        return (
            <div className={classes} ref={this.dropdownRef}>
                {this.props.expanded && (
                    <div className="dropdown-checkbox__popup">
                        <div className="dropdown-checkbox__options">{list}</div>
                        <div className="dropdown-checkbox__popup__footer">
                            <button
                                type="button"
                                className="button button-secondary button--wide button--slim"
                                onClick={this.checkboxSubmitHandler}
                            >
                                {selectBtnText}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default DropdownCheckboxes;
